import React, { useCallback, useContext, useState } from 'react';
import {
  ButtonRow,
  CloseButton,
  Container,
  ContainerLoader,
  ContainerRow,
  SearchNCM,
} from './styles';
import FormDefault from '~/components/FormDefault';
import { useManutencaoFiscalNfce } from './ManutencaoFiscalNfceContext';
import Search from '~/components/Search';
import { GridRowParams } from '@material-ui/data-grid';
import DefaultLoader from '~/components/DefaultLoader';
import { IoCheckmarkCircleSharp } from 'react-icons/io5';
import { InputMaskNcm } from '~/components/NovosInputs';
import { Col, Modal, Row } from 'react-bootstrap';
import { CustomButtonNovo } from '~/components/Buttons/CustomButtonNovo';
import { CustomDataGrid, CustomGridColumns } from './components/CustomDataGrid';
import { GoPencil } from 'react-icons/go';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@material-ui/core';
import { AiOutlineClose, AiOutlineQuestionCircle } from 'react-icons/ai';
import { IoIosClose, IoIosSearch } from 'react-icons/io';
import useDebounce from '~/hooks/useDebounce';
import api from '~/services/api';
import { ClipLoader } from 'react-spinners';
import { ThemeContext } from 'styled-components';
import { updateItensFiscal } from './services/updateItensFiscal';
import { HiXCircle } from 'react-icons/hi';
import { MdBlock } from 'react-icons/md';
import { formatNcm } from '~/components/NovosInputs/InputMaskNcm/utils/formatNcm';
import { toast } from 'react-toastify';

const ManutencaoFiscalNfceContent: React.FC = () => {
  const {
    showSearch,
    setShowSearch,
    onRowClick,
    handleResetForm,
    loader,
    update,
    itensFiscal,
    setItensFiscal,
    openNcmList,
    setOpenNcmList,
    numNcm,
    setNumNcm,
    disabled,
    setDisabled,
    formManutencaoFiscalNFCE: {
      watch,
      reset,
      control,
      register,
      setValue,
      setError,
      getValues,
      setFocus,
      formState: { errors },
      clearErrors,
      handleSubmit,
      trigger,
    },
  } = useManutencaoFiscalNfce();
  const { debouncedFn } = useDebounce();
  const { colors } = useContext(ThemeContext);

  const [searchNcm, setSearchNcm] = useState<string>('');
  const [loadingNcmValidation, setLoadingNcmValidation] =
    useState<boolean>(false);
  const [NcmList, setNcmList] = useState<any[]>([]);

  const [inputValidate, setInputValidate] = useState<any[]>([]);

  // Columns
  const associadoColumns: CustomGridColumns[] = [
    {
      field: 'id',
      headerName: 'Id',
      hide: true,
      width: 300,
      disableColumnMenu: true,
    },
    {
      field: 'cod_item',
      headerName: 'Cód. Item',
      hide: true,
      width: 50,
      disableColumnMenu: true,
    },
    {
      field: 'num_item',
      headerName: 'Núm. Item',
      width: 50,
      disableColumnMenu: true,
    },
    {
      field: 'cod_seq_cupom',
      headerName: 'Cód. Seq Cupom',
      hide: true,
      width: 50,
      disableColumnMenu: true,
    },
    {
      field: 'des_produto',
      headerName: 'Descrição',
      width: 500,
      sortable: false,
      disableColumnMenu: true,
    },
    {
      field: 'num_ncm',
      headerName: 'NCM',
      sortable: false,
      width: 50,
      disableColumnMenu: true,
      renderCell: (params: any) => {
        const { num_ncm } = params;
        return num_ncm ? formatNcm(params.num_ncm) : '';
      },
    },
  ];

  const actions: CustomGridColumns[] = [
    {
      field: 'acoes',
      headerName: 'Ações',
      fixed: true,
      fixedDirection: 'left',
      width: 100,
      renderCell: (row: any) => {
        const onEdit = () => {
          setDisabled(false);
          setValue('num_ncm', row.num_ncm);
          setValue('cod_item', row.cod_item);
          setNumNcm(row.num_ncm);
          setValue('id', row.id);
        };

        return (
          <ButtonRow
            disabled={false}
            style={{ width: '100%' }}
            type="button"
            onClick={onEdit}
            aria-label="Editar"
          >
            <GoPencil size={20} style={{ color: '#72AB90' }} /> Editar
          </ButtonRow>
        );
      },
    },
  ];

  const columns: CustomGridColumns[] = [...associadoColumns, ...actions];

  async function filterNcmValidation(search: string) {
    if (search.length >= 3) {
      setLoadingNcmValidation(true);
      const { data } = await api.get('/buscar-catalogo-ncm', {
        params: { search, num_ncm: null },
      });

      if (data.success && data.data) {
        const ncmData = data.data;
        const sortedNcmData = [...ncmData];
        setNcmList(
          sortedNcmData.sort((a, b) => a.des_ncm.localeCompare(b.des_ncm)),
        );
        setInputValidate([]);
      }
      setLoadingNcmValidation(false);
    }
  }

  function handleNCMValidation(item: any) {
    if (item) {
      setValue('num_ncm', item.num_ncm);
      setValue('num_des_ncm', item.des_ncm);
      setNumNcm(item.num_ncm);
      const allValidates = inputValidate;
      const IndexValidatedNcm = allValidates.findIndex(
        (itemNcm: any) => itemNcm.Field === 'num_ncm',
      );
      const IndexValidatedDes = allValidates.findIndex(
        (itemDes: any) => itemDes.Field === 'descricao',
      );

      if (allValidates[IndexValidatedNcm]?.Invalid) {
        allValidates[IndexValidatedNcm].Invalid = false;
      }
      if (allValidates[IndexValidatedDes]?.Invalid) {
        allValidates[IndexValidatedDes].Invalid = false;
      }
      setInputValidate(allValidates);

      setOpenNcmList(false);
    }
  }

  const handleChangeSearchNcm = useCallback(
    (value) => {
      const sanitizedValue = value.includes('.')
        ? value.replace(/\./g, '')
        : value;

      setSearchNcm(value);
      debouncedFn(() => filterNcmValidation(sanitizedValue), 700);
    },
    [debouncedFn, filterNcmValidation],
  );

  const handleSaveNcmItem = handleSubmit(async (values: any) => {
    const { id, num_ncm, cod_item, cod_seq_cupom } = values;
    const itensFiscalUpdated = itensFiscal;
    const itensFiscalIndex = itensFiscal.findIndex((i: any) => i.id === id);

    const formatedNumNcm = num_ncm ? num_ncm.replace(/\./g, '') : '';
    if (formatedNumNcm.length < 8) {
      return toast.warning('NCM inválido');
    }

    if (itensFiscalIndex !== -1) {
      itensFiscalUpdated[itensFiscalIndex].num_ncm = formatedNumNcm;
    }

    const payload = {
      num_ncm: formatedNumNcm,
      cod_item,
    };
    await updateItensFiscal(Number(cod_seq_cupom), payload);
    handleResetForm();
    setItensFiscal(itensFiscalUpdated);
    setOpenNcmList(false);
    setSearchNcm('');
    setNcmList([]);
  });

  const handleRenderIconTitle = (tipo_status: number) => {
    switch (tipo_status) {
      case 0:
        return (
          <IoCheckmarkCircleSharp style={{ marginTop: '-5px' }} color="green" />
        );
        break;
      case 1:
        return <HiXCircle color="red" style={{ marginTop: '-5px' }} />;
        break;
      case 2:
        return <MdBlock color="orange" style={{ marginTop: '-5px' }} />;
        break;
      case 3:
        return (
          <AiOutlineQuestionCircle color="gray" style={{ marginTop: '-5px' }} />
        );
        break;
      default:
        return (
          <IoCheckmarkCircleSharp style={{ marginTop: '-5px' }} color="green" />
        );
        break;
    }
    tipo_status;
  };

  if (loader) {
    return (
      <Container>
        <DefaultLoader />
      </Container>
    );
  }

  return (
    <Container>
      {showSearch && (
        <Search
          newData={() => setShowSearch(false)}
          onRowClick={onRowClick}
          codTela={309}
          onlyReport
        />
      )}
      {!showSearch && (
        <>
          <FormDefault
            codTela={309}
            title="Manutenção Fiscal - NFCe"
            onSave={() => Promise.resolve()}
            onCancel={() => []}
            onClearFields={() => []}
            onNew={() => []}
            onDelete={() => []}
            onReturnSearch={() => {
              handleResetForm();
              setShowSearch(true);
            }}
            isUpdate={update}
            isDelete={false}
            isSave
            isNew={false}
          >
            <h3
              style={{
                fontSize: '20px',
                marginBottom: '20px',
                marginTop: '20px',
              }}
            >
              {`PDV: ${getValues('num_pdv')} | Lj: ${getValues(
                'cod_loja',
              )} | Data hora: ${getValues('dta_cupom')} |`}{' '}
              {handleRenderIconTitle(getValues('tipo_status'))}
              {getValues('des_tipo_status')}
            </h3>

            <Row>
              <Col sm={12} md={3}>
                <InputMaskNcm
                  label="NCM"
                  name="num_ncm"
                  hasButton
                  control={control}
                  register={register}
                  clickedButton={() => setOpenNcmList(true)}
                  isError={!!errors.num_ncm}
                  disabled={disabled}
                />
              </Col>
              <Col
                sm={12}
                md={2}
                style={{
                  display: 'flex',
                  height: '70px',
                  alignItems: 'flex-end',
                }}
              >
                <CustomButtonNovo
                  onClick={() => {
                    handleResetForm();
                    setSearchNcm('');
                    setNcmList([]);
                  }}
                  label="Cancelar"
                  // icon={null}
                  disabled={disabled}
                  variant="error"
                  style={{ width: '100%' }}
                />
              </Col>
              <Col
                sm={12}
                md={2}
                style={{
                  display: 'flex',
                  height: '70px',
                  alignItems: 'flex-end',
                }}
              >
                <CustomButtonNovo
                  onClick={() => {
                    handleSaveNcmItem();
                  }}
                  label="Gravar"
                  // icon={null}
                  disabled={disabled}
                  variant="confirm"
                  style={{ width: '100%' }}
                />
              </Col>
              <Col
                md={12}
                sm={12}
                style={{ marginTop: '0.625rem', height: '25rem' }}
              >
                <CustomDataGrid rows={itensFiscal} columns={columns} />
              </Col>
            </Row>
          </FormDefault>{' '}
          <Modal
            show={openNcmList}
            onHide={() => {
              setOpenNcmList(false);
              setSearchNcm('');
              setNcmList([]);
            }}
            size="lg"
          >
            <Modal.Header
              style={{
                paddingBottom: '0.5rem',
              }}
            >
              <Modal.Title>Selecione o NCM</Modal.Title>
              <CloseButton
                onClick={() => {
                  setOpenNcmList(false);
                  setSearchNcm('');
                  setNcmList([]);
                }}
              >
                <AiOutlineClose size={24} />
              </CloseButton>
            </Modal.Header>
            <Modal.Body>
              <div className="row p-2 d-flex content-around gap-4">
                <div className="col-12 col-md-12">
                  <SearchNCM>
                    <IoIosSearch focusable={false} aria-hidden="true" />
                    <input
                      type="text"
                      spellCheck="false"
                      placeholder="Pesquisar"
                      autoComplete="off"
                      // eslint-disable-next-line jsx-a11y/no-autofocus
                      autoFocus
                      value={searchNcm}
                      onChange={(e) => {
                        handleChangeSearchNcm(e.target.value);
                      }}
                    />
                    <button
                      type="button"
                      onClick={() => {
                        setSearchNcm('');
                        setNcmList([]);
                      }}
                    >
                      <IoIosClose style={{ cursor: 'pointer' }} />
                    </button>
                  </SearchNCM>
                </div>
                <div className="col-12 col-md-12">
                  {loadingNcmValidation ? (
                    <ContainerLoader style={{ height: '250px' }}>
                      <ClipLoader color={colors.primary} />
                    </ContainerLoader>
                  ) : (
                    <TableContainer style={{ height: '250px' }}>
                      <Table size="small">
                        <TableHead
                          style={{ position: 'sticky', top: 0, zIndex: 1 }}
                        >
                          <TableRow>
                            <TableCell style={{ width: '50px' }}>NCM</TableCell>
                            <TableCell style={{ maxWidth: '600px' }}>
                              Descrição
                            </TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {NcmList.map((item) => {
                            return (
                              <TableRow
                                key={item.num_ncm}
                                title="Clique sobre o NCM para selecioná-lo"
                                style={{
                                  background:
                                    item.num_ncm === numNcm
                                      ? '#85edad'
                                      : 'none',
                                }}
                                onClick={() => handleNCMValidation(item)}
                              >
                                <TableCell>{item.num_ncm}</TableCell>
                                <TableCell>{item.des_ncm}</TableCell>
                              </TableRow>
                            );
                          })}
                        </TableBody>
                      </Table>
                      {NcmList.length < 1 && (
                        <>
                          {searchNcm.length < 4 ? (
                            <ContainerRow>
                              <span>
                                Informe pelo menos 3 caracteres para pesquisar
                              </span>
                            </ContainerRow>
                          ) : (
                            <ContainerRow>
                              <span>Nenhum registro encontrado</span>
                            </ContainerRow>
                          )}
                        </>
                      )}
                    </TableContainer>
                  )}
                </div>
              </div>
            </Modal.Body>
          </Modal>
        </>
      )}
    </Container>
  );
};

export default ManutencaoFiscalNfceContent;
